<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div ref="chart" class="chart"></div>
    </div>
    <!-- <img
      src="~@/assets/images/granary/xmy/echart1.png"
      alt=""
      class="echarts-img"
    /> -->
  </div>
</template>

<script>
import { loadChart } from "./charts/cclData";
import { findQueryList } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["牛", "山羊", "猪", "家禽", "兔"],
      active: 0
    };
  },
  mounted() {
    this.getData();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);
      findQueryList({
        code: "ccl_zzt",
        series: this.typeList[this.active]
      }).then(res => {
        const data = res.data;
        if (data instanceof Array) {
          let slist = [];
          let chuData = [];
          let cunData = [];
          data.forEach(ele => {
            slist.push(ele.dq);
            chuData.push(Number(ele.chul));
            cunData.push(Number(ele.cl));
          });
          loadChart(this.chart, slist, cunData, chuData);
        }
      });

      // const xData = ["茂南区", "电白区", "信宜市", "高州市", "化州市"];
      // const cunData = [
      //   [8114, 33358, 34710, 47243, 44678],
      //   [5340, 22906, 7099, 1986, 39906],
      //   [134123, 459954, 285117, 487416, 570265],
      //   [6957640, 9515946, 32179906, 13378428, 8258562],
      //   [1846, 40575, 208969, 57046, 30214]
      // ]; //存栏数量
      // const chuData = [
      //   [1296, 4662, 6385, 5797, 6513],
      //   [3632, 16046, 78379, 17098, 8530],
      //   [691572, 1199750, 841401, 1210729, 1275019],
      //   [32811426, 30999703, 72762771, 48222299, 24616888],
      //   [5382, 61435, 368209, 174160, 37968]
      // ];//出栏数量
      // loadChart(this.chart, xData, cunData[this.active], chuData[this.active]);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .tab-box
      position absolute
      top 5px
      right 2%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff

  .echarts-img
    height 240px
    margin 0 auto
    display block
</style>
